import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { configuration, dataLayer, privacy } from '@dpgradio/creative'
import './style.css'
import App from './App.vue'

const initialize = async () => {
  await configuration.retrieveConfigForStation('qmusic_nl')

  const pinia = createPinia()
  const app = createApp(App)

  app.use(pinia)
  app.mount('#app')

  privacy.initialize()
  dataLayer.initialize()
  dataLayer.setCampaignDetails({
    name: 'Toetjesdag',
    type: 'button',
    station: 'qmusic_nl',
  })
  dataLayer.pushVirtualPageView()
}

window.createVueApp = initialize
window.createVueApp()
